
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import iView from 'iview';
	import AbpBase from '@/lib/abpbase'	
	@Component({
		components: {

		}
	})
	export default class Preview extends AbpBase {
		// @Prop({
		// 	type: Boolean,
		// 	default: false
		// }) value: boolean;
		value: boolean = false;
		currentUrl: string = '';
		showClosable: boolean = true;
		newsGroup: Object = new Object();
		groupid: number = 0;
		userInfo: Object = new Object();
		detailUrl: string = '';
		iframeBox: boolean = false;
		
		returnList(){
			this.detailUrl = '';
			this.iframeBox = false;
		}

		copy() {
			let url = window.location.href;
			//let url = this.currentUrl.replace("newsgroup", "preview") + "?groupid=" + this.groupid;
			let oInput = document.createElement('input');
			oInput.value = url;
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象;
			console.log(oInput.value)
			document.execCommand("Copy"); // 执行浏览器复制命令
			this.$Message.success(this.L('CopySuccess'));
			oInput.remove()
		}
		goNewsDetail(newsid) {
			window.open('#/newsdetail?newid='+newsid+'&preview=1');
		// 	var url = "https://gis.yfpo.com/#/newsdetail?newid=" + newsid;
		// 	if (Util.abp.session.userId) {
		// 		url = url + "&domain=" + (this.userInfo as any).domainAccount;
		// 	}
		// 	this.detailUrl = url;
		// 	this.iframeBox = true;		
		
		// 	this.$forceUpdate();
			// window.open(url, '_blank');
		}
		getNewsGroupByID(groupid) {
			var that = this;
			that.groupid = groupid;
			this.detailUrl = '';
			this.iframeBox = false;
			that.$Message.loading({
				content: this.L('Loading'),
				duration: 3
			});
			this.$store.dispatch({
				type: 'app/getNewsGroupById',
				id: groupid
			}).then((res) => {
				console.log(res);
				that.$Message.destroy()
				that.newsGroup = res as Object;

				//that.loadNewsTo();
			})
		}		
		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.groupid != from.query.groupid) {
				location.reload();
			}
		}
		async created() {
			var that = this;
			this.currentUrl = window.location.href;			
			if (this.$route.query && (this.$route.query.groupid as any) > 0) {
				this.value = true;
				this.showClosable = false;
				this.groupid = this.$route.query.groupid as any;
				this.getNewsGroupByID(this.groupid);
			}
			if (Util.abp.session.userId) {
				this.$store.dispatch({
					type: 'app/getLoginUser',
					data: {}
				}).then(res => {
					that.userInfo = res;
				})
			}

		}


	}
